<footer class="footer">

    <div class="container-redesign">

        <div class="footer__wrapper">

            <div class="footer__brand">
                <a routerLink="/home-redesign" class="footer__logo">
                    <img src="/assets/img/white-logo.png" alt="Althea Soft">
                </a>
                <p class="footer__copyright">
                    © Althea Soft Ltd. All rights reserved.
                </p>
            </div>

            <div class="footer__links">
                <h3>Explore</h3>
                <a *ngFor="let link of exploreLinks; trackBy: trackByLabel" [routerLink]="link.route">
                    {{ link.label }}
                </a>
            </div>

            <div class="footer__links">
                <h3>Menu</h3>
                <a *ngFor="let link of menuLinks; trackBy: trackByLabel" [routerLink]="link.route">
                    {{ link.label }}
                </a>
            </div>

            <div class="footer__contact">
                <h3>OFFICE LOCATION</h3>
                <div class="footer__office">
                    <img src="/assets/img/redesign/footer/location.svg" alt="Location">
                    <p>
                        Head Office: 35 Woodlark road<br>
                        Newbury, RG142FY, UK
                    </p>
                </div>
                <div class="footer__office">
                    <img src="/assets/img/redesign/footer/location.svg" alt="Location">
                    <p>
                        Estonia Office: Harju maakond, Tallinn,<br>
                        Nõmme linnaosa, Pärnu mnt 388b<br>
                        11612, ESTONIA
                    </p>
                </div>
                <div class="footer__office">
                    <img style="height: 20px;" src="/assets/img/redesign/contact/phone.svg" alt="Phone">
                    <p>
                        UK: +44 333 224 8250
                    </p>
                </div>
            </div>

            <!-- FIXED POSITION: Moved inside footer__wrapper -->
            <div class="footer__bottom">
                <div class="row align-items-center text-white w-100 m-0">
                    <div class="col-md-7 p-0">
                        <p class="mb-md-0 text-white">© AltheaSoft - Detect Mental Health Risks Earlier with AI-Driven Monitoring</p>
                    </div>
                    <div class="col-md-5 p-0">
                        <ul class="d-flex list-unstyled justify-content-md-end mb-0 gap-3">
                            <li><a class="text-white text-decoration-none" routerLink="/privacy" href="/privacy">Privacy Policy</a></li>
                            <li><a class="text-white text-decoration-none" routerLink="/term-conditions" href="/term-conditions">Terms &amp; Conditions</a></li>
                        </ul>
                    </div>
                </div>
            </div>

        </div> <!-- /footer__wrapper -->

    </div> <!-- /container-redesign -->

</footer>
